import React, { Component } from 'react';
import PropTypes from 'prop-types';

class CommentsErrorBoundary extends Component {
    static propTypes = {
        children: PropTypes.any
    };

    constructor(props) {
        super(props);
        this.state = { hasError: false, error: {} };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    render() {
        if (this.state.hasError) {
            return (
                <section className={'col-12'}>
                    <div className={'col-md-3 trackSectionPanel'}>
                        <section className={'pagePanel'}>
                            <h4>The Following Error Has Occurred</h4>
                            <div>{this.state.error.toString()}</div>
                        </section>
                    </div>
                    <div className={'col-md-9 trackSectionBuilder'} />
                </section>
            );
        }
        return this.props.children;
    }
}

export default CommentsErrorBoundary;
